<li *accessVisibility="accessVisibilityIn">
  <ng-container *ngIf="routerLink;else hrefTemplate">
    <a type="button" class="dropdown-item" [ngClass]="buttonClass" [accessDisable]="accessDisableIn"
      [routerLink]="routerLink ? routerLink : []" [target]="target">
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </a>
  </ng-container>
  <ng-template #hrefTemplate>
    <ng-container *ngIf="href; else noHrefTemplate">
      <a type="button" class="dropdown-item" [ngClass]="buttonClass" [accessDisable]="accessDisableIn" [target]="target"
        [href]="href">
        <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
      </a>
    </ng-container>
  </ng-template>
  <ng-template #noHrefTemplate>
    <a type="button" class="dropdown-item" [ngClass]="buttonClass" [accessDisable]="accessDisableIn" [target]="target">
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </a>
  </ng-template>
</li>
<ng-template #contentTemplate>
  <i *ngIf="iconClass" [ngClass]="iconClass" class="align-middle me-1"></i>
  <ng-content></ng-content>
</ng-template>